import MetaDecorator from "../../components/MetaDecorator";
import "../../utils/document.scss";

const PRIVACY = "http://www.thetotemchat.com/help/privacy";

const PrivacyPolicy = () => {
  return (
    <>
    <MetaDecorator title="Конфиденциальность" desc="Правила Конфиденциальности" imageUrl="https://images.pexels.com/photos/14186574/pexels-photo-14186574.jpeg?auto=compress&cs=tinysrgb&w=1600&lazy=load" url={PRIVACY} />
    <main className="document">
      <div className="document__content">
        <section className="document__section">
          <h2 className="document__section-title">Totem Chat Privacy Policy</h2>
          <p className="document__section-paragraph">
            Totem Chat Inc. (“Totem Chat,” “we” and “us”) believes privacy is
            incredibly important and pledges to respect and protect its users.
          </p>
          <p className="document__section-paragraph">
            The Totem Chat application (the “App”) is made available as a mobile
            application, and information regarding the application is available
            on Totem Chat’s website located at{" "}
            <a
              href="http://www.thetotemchat.com/"
              target="_blank"
              rel="noreferrer"
            >
              www.thetotemchat.com
            </a>
            . The Totem Chat application, website, and related services will be
            referred to as the “Services.” The App offers users a forum to
            interact with other Totem Chat users in the same geographic area. In
            this Privacy Policy (“Policy”), we describe how we collect, use, and
            disclose information that we obtain about users of the Services.
          </p>
          <p className="document__section-paragraph">
            We ask that you read the Policy in order to understand how your
            information is being used. When you use the Services, you are
            consenting to this Policy. If you do not agree with content in the
            Policy, you must stop using the Services.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">
            What Information We Collect
          </h2>
          <p className="document__section-paragraph">
            <span className="document__bold-text">
              Personal Information We Collect Automatically.
            </span>
            Personal information is information that identifies or is capable of
            identifying you as an individual. We collect personal information
            from you when you voluntarily provide it to us.
          </p>
          <p className="document__section-paragraph">
            In order to use the App, you must register with your email address.
            When you post a message, we collect the time the message was posted,
            the location the message was posted from, and the message’s content.
          </p>
          <p className="document__section-paragraph">
            We may automatically collect information about your use of the
            Services such as: access/log-in and log-out time, IP address, device
            ID, application ID or other unique identifier; domain name, screen
            views; geo-location data (with your permission); language
            information; device name and model; operating system information,
            browser type and language and version of the browser software; your
            activities within the Services; and the length of time that you are
            logged in. We may combine this information with other information
            that we have collected about you. Such data is collected, as without
            such data the Services cannot be accessed.
          </p>
          <p className="document__section-paragraph">
            If you choose not to share your location information, the Services
            will not function. Location information is used to place you in your
            local / home Totem Chat group, to enable you to find and connect
            with local users, and to enable local users to find and connect with
            you. You can revoke your consent by changing the settings or
            preferences on your device or by deleting Totem Chat from your
            device.
          </p>
          <p className="document__section-paragraph">
            <span className="document__bold-text">Your Content and Usage.</span>{" "}
            We may collect content you submit to the Services, information about
            the content, such as when you submitted it, and any metadata that is
            provided with the content.
          </p>
          <p className="document__section-paragraph">
            <span className="document__bold-text">
              Other Information you Provide to Us.
            </span>{" "}
            When you interact with the Services or otherwise communicate with
            Totem Chat in any way, we may collect the information you choose to
            share with us.
          </p>
          <p className="document__section-paragraph">
            <span className="document__bold-text">Social Media Sites.</span> You
            can like us on Facebook, follow us on Twitter and Instagram, and
            promote us on other social media sites. We collect information about
            who has liked us or followed us.
          </p>
          <p className="document__section-paragraph">
            <span className="document__bold-text">
              Aggregate and Anonymous Information.
            </span>{" "}
            Sometimes we use aggregate or anonymous information. Anonymous
            information is data where all information that enabled you to be
            identified has been removed. Aggregated information is anonymous
            data collected about a group of users or other categories. Your
            personal information is not included in aggregate or anonymous data.
            We may use this type of information, for example, to help us
            understand trends and your needs and preferences and to improve our
            services. This policy does not restrict our use of aggregate and
            anonymous information.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">
            How We Use Information We Collect
          </h2>
          <p className="document__section-paragraph">
            In general, we use the information we collect from and about you to
            provide and operate the Services, respond to your requests, and
            provide customer service and technical support. Due to your use of
            the App or communication with Totem Chat, some of the information we
            collect may personally identify you. The personally identifiable
            information you may submit during your use of the App could include
            phone number and geographic location. We will not ask for other
            identifying information from you but you may voluntarily provide it
            to us in communications with us such as email queries in which you
            voluntarily provide your email address.
          </p>
          <p className="document__section-paragraph">
            Other data that could be collected from your use of Totem Chat is
            not considered personally identifiable information, except if that
            information is combined with personally identifiable information or
            unless otherwise required by applicable law. We may also use
            information:
          </p>
          <ul className="document__list">
            <li className="document__list-item">
              To place you in your local Totem so that you can post and review
              content based on your current location.
            </li>
            <li className="document__list-item">
              To enable you to find and connect with users in your proximity
              i.e. local users and for them to find and connect with you.
            </li>
            <li className="document__list-item">
              To tag your posts with city-level location information.
            </li>
            <li className="document__list-item">
              To enable you to search for local users by status.
            </li>
            <li className="document__list-item">
              To place you in your home Totem Chat group so that you can post
              and review content in your community even when you are away.
            </li>
            <li className="document__list-item">
              To tailor the information that we send or display to you, offer
              location customization, and send you push notifications and
              alerts.
            </li>
            <li className="document__list-item">To send you notices.</li>
            <li className="document__list-item">
              To display advertising, including advertising that is targeted to
              you based on your location and your Totem Chat activities.
            </li>
            <li className="document__list-item">
              To verify your identity and prevent impersonation, spam or other
              unauthorized or illegal activity or activity that violates our
              Terms of Use.
            </li>
            <li className="document__list-item">
              To comply with laws, regulations, and other legal requirements.
            </li>
            <li className="document__list-item">
              To comply with relevant industry standards and our policies.
            </li>
            <li className="document__list-item">
              To protect and enforce our rights arising under any agreements
              entered into between you and us.
            </li>
            <li className="document__list-item">
              To protect the integrity and maintain the security of the App,
              including secured areas of the App.
            </li>
            <li className="document__list-item">
              To better understand how users access and use the Services, both
              on an aggregated and individualized basis, in order to improve the
              Services and respond to user desires and preferences, and for
              other research and analytical purposes.
            </li>
          </ul>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">
            Where Information is Processed
          </h2>
          <p className="document__section-paragraph">
            Totem Chat is based in the Kazakhstan. No matter where you are
            located, please be advised that you are transferring your personal
            information to us in the United States, and by using our Services,
            you consent to that transfer and use of your personal information in
            accordance with this Policy. If you are a user outside of the United
            States, please know that any information you provide on our Services
            may be transferred to the United States, which does not offer an
            equivalent level of protection to that required in certain other
            countries. Some local privacy laws may require us to obtain your
            consent before we transfer your information from your originating
            country to other countries. When you agree to this Policy, you are,
            to the extent required and permitted under your local law, granting
            your consent to the transfer of your personal information to such
            other countries for the purposes described in this Policy. These
            countries may not have the same data protection laws as the country
            in which you initially provided the information. We take steps to
            ensure that it is adequately protected in compliance with applicable
            laws, including ensuring appropriate security measures are in place
            and requiring the third parties to protect your personal information
            in accordance with this Policy, or obtaining your consent where
            required. You also agree to abide by applicable law concerning your
            use of the Services and your agreements with us. Any persons
            accessing the Services from any jurisdiction with laws or
            regulations governing the use of the Internet, including personal
            data collection, use and disclosure, different from those of the
            jurisdictions mentioned above may only use the Services in a manner
            lawful in their jurisdiction. If your use of the Services would be
            unlawful in your jurisdiction, you may not use the Services, and
            your information may be made available in response to government or
            law enforcement requests.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">How We Share Information</h2>
          <p className="document__section-paragraph">
            You cannot control who views the content you post on a Totem Chat
            feed, as it is publicly available. So, if you don’t want to share
            something publicly, don’t post it.
          </p>
          <p className="document__section-paragraph">
            The information we collect, including personally identifiable
            information, may be shared as follows:
          </p>
          <ul className="document__list">
            <li className="document__list-item">
              <span className="document__bold-text">Totem Chat Users</span> Any
              information that you (i) post, (ii) link to (for example, your
              Facebook account), or (iii) send (for example, chats) may be
              shared with other users and potentially the public at large,
              depending on the type of feature you are using. For example, any
              posts on a Totem Chat feed are available to all other users and
              may be publicly distributed, and any status you post can be used
              to search for users with that “type” of status (i.e.
              studyingForExams, watchingFootball). Users can freely save or
              re-share any Totem Chat content on and off the Services.{" "}
              <span className="document__bold-text">
                Please don’t post content or send messages you wouldn’t want
                others to save or share.
              </span>
            </li>
            <li className="document__list-item">
              <span className="document__bold-text">Service Providers.</span> We
              may disclose the information we collect to third-party vendors,
              service providers, contractors or agents who perform functions on
              our behalf. When we do so, we require those third parties to
              protect your personal information in accordance with this Policy
              and applicable laws.
            </li>
            <li className="document__list-item">
              <span className="document__bold-text">Business Transfers.</span>{" "}
              We may transfer the information we have collected to another
              company in connection with, or during negotiations of, any
              dissolution, bankruptcy or similar event, merger, sale of company
              assets, financing, or acquisition of all or a portion of the
              business.
            </li>
            <li className="document__list-item">
              <span className="document__bold-text">
                Third Parties and Partners.
              </span>{" "}
              Subject to our legal obligations with respect to your personal
              information, we may share the information with our third-party
              partners, including advertisers and researchers. For example, if
              you post content that mentions one of our advertisers, we may
              share that content with them. Or, we may work with a researcher to
              analyze the content on a particular feed. Once you leave our
              Services and are directed to another site or application, however,
              this Policy and our Terms of Use no longer apply and the terms and
              policies on such third-party site apply.
            </li>
            <li className="document__list-item">
              <span className="document__bold-text">
                In Response to Legal Process.
              </span>{" "}
              We may disclose the information in order to comply with the law, a
              judicial proceeding, court order, subpoena, or other legal
              process. For example, we may share your phone number or other
              identifier, your location information, or any other information we
              have collected about you and your device.
            </li>
            <li className="document__list-item">
              <span className="document__bold-text">
                To Protect Us and Others.
              </span>{" "}
              We also may disclose information if we believe it is necessary to
              investigate, prevent, or take action regarding illegal activities,
              suspected fraud, situations involving potential threats to the
              safety of any person, violations of our Terms of Service or this
              Policy, or as evidence in litigation in which Totem Chat is
              involved.
            </li>
            <li className="document__list-item">
              <span className="document__bold-text">
                Aggregate and De-Identified Information.
              </span>{" "}
              We may also share aggregate or de-identified information about
              users with third parties for marketing, advertising, research or
              similar purposes, as described further below.
            </li>
          </ul>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Invite Contacts</h2>
          <p className="document__section-paragraph">
            You can choose to “Share Totem Chat” by inviting contacts via email,
            text or other means. You choose what contacts to invite and when to
            invite them. If you invite a contact, we will generate a message
            with the Totem Chat download URL included, which you can choose to
            send via your mobile device.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Your Content</h2>
          <p className="document__section-paragraph">
            You can delete content you have posted on a Totem Chat feed
            (including replies). Content you delete from a Totem Chat feed will
            be hidden from other users. However, Totem Chat may maintain a copy
            of your content in our records, subject to applicable law and this
            Policy.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">
            How to Access and Control your Information
          </h2>
          <p className="document__section-paragraph">
            You may change your privacy settings at any time by contacting us at
            hello@thetotemchat.com.com. You may indicate your options to:
          </p>
          <ul className="document__list">
            <li className="document__list-item">
              Modify, update, and delete your user account;
            </li>
            <li className="document__list-item">
              Opt in or opt out of subscriptions to newsletters, mailings, and
              other communications and alerts, to the extent we offer any;
            </li>
            <li className="document__list-item">
              Opt in or out of receiving offers and promotions; and
            </li>
            <li className="document__list-item">
              Opt in or opt out of sharing your personal information with others
              so they can send you offers and promotions.
            </li>
          </ul>
          <p className="document__section-paragraph">
            You may contact us to request a copy of the information we have
            collected about you, request to correct or update any information we
            have about you, or request deletion of your account or personal
            information. Following a request for deletion, we will delete your
            information unless required to retain it by applicable laws. We may
            also retain certain of your information if necessary for safety or
            security, fraud prevention, quality assurance, or other legitimate
            business interests, and only in accordance with applicable laws.
          </p>
          <p className="document__section-paragraph">
            You may withdraw any consent you have granted to our collection and
            use of your personal information at any time, subject to our right
            to continue to use your personal information as permitted or
            required under applicable laws. Such withdrawal will not affect the
            lawfulness of our collection or use of your personal information
            prior to withdrawal.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Do-Not-Track Notice</h2>
          <p className="document__section-paragraph">
            Because there is not yet a consensus on how companies should respond
            to web-browser-based do-not-track mechanisms, we do not respond to
            do-not-track signals at this time.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">
            How Long We Retain Your Information
          </h2>
          <p className="document__section-paragraph">
            We retain your information only as long as necessary to provide our
            services to you, enhance your user experience, and otherwise as
            necessary for our operations or as permitted or required by
            applicable laws.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Push Notifications/Alerts</h2>
          <p className="document__section-paragraph">
            We may send push notifications or alerts to your device. You can
            deactivate these messages at any time by changing the notification
            settings on your device or by changing your Totem Chat settings
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Text Alerts</h2>
          <p className="document__section-paragraph">
            Totem Chat may send you information, updates or promotional offers
            via text message. If you indicate your desire to receive such
            messages, you have the ability to opt out at any time. Please note
            that your carrier’s text messaging and data fees apply.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">
            Legal Basis for Use of Your Personal Information (GDPR)
          </h2>
          <p className="document__section-paragraph">
            The General Data Protection Regulation, or GDPR, governs privacy
            practices involving individuals in the European Union and the
            European Union and the European Economic Area and certain other
            transactions related to those areas. If the GDPR applies to your
            personal information that we have collected, our legal basis for
            collecting and using your personal information will depend on the
            personal information concerned and the context in which it is
            collected, including legitimate business purposes, as necessary to
            provide products and services to you or respond to your inquiries
            and requests, with your consent, to comply with applicable laws, or
            when there is a legitimate and overriding interest that necessitates
            the use.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Cookies</h2>
          <p className="document__section-paragraph">
            “Cookies” are small data file identifiers that are transferred to
            your computer that allow us to recognize your browser and transfer
            information about you and your use of the Services. For example,
            cookies that we use tell us how many times you have visited one of
            our Sites. We use “persistent” cookies and similar technologies to
            save your login information for future logins to the Services. We
            also use “session ID” cookies and similar technologies to enable
            certain features of the Services, to better understand how you
            interact with the Services and to monitor aggregate usage by users
            and web traffic routing on the Services. Unlike persistent cookies,
            session ID cookies are deleted from your computer when you log off
            from a Service and close your browser. You can instruct your
            browser, by changing its settings, to stop accepting cookies or to
            prompt you before accepting a cookie from our Sites. If you do not
            accept cookies, you may not be able to use all portions of the
            Services or all functionality of the Services. You can read more
            about our use of cookies in our Cookies Policy.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">
            How Long We Retain Your Information
          </h2>
          <p className="document__section-paragraph">
            We retain your information only as long as necessary to provide our
            Services to you, enhance your user experience, and otherwise as
            necessary for our operations or as permitted or required by
            applicable laws.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Third-Party Analytics</h2>
          <p className="document__section-paragraph">
            We may use automated devices and applications, including those
            offered by third parties to evaluate usage of the Services. We also
            may use other analytic means to evaluate our Services. We use these
            tools to help us improve the Services, performance and user
            experiences. The information collected may include unique device
            identifiers, device manufacturer and operating system, browser type,
            session start/stop time, and user activity.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Third-Party Links</h2>
          <p className="document__section-paragraph">
            Our Services may contain third-party links, including third-party
            integrations. Any access to and use of such links or third-party
            integrations is not governed by this Policy, but instead is governed
            by the privacy policies of those third parties. Once you leave our
            Services and are directed to another site or application, this
            Policy and our Terms of Use no longer apply and the terms and
            policies on such third-party site apply. You have the choice whether
            to access the links to these sites, initiate the transaction or
            activate the features. This Policy does not apply to any third-party
            linked sites, and we are not responsible for the privacy practices
            or the contents of such external sites. We encourage you to consult
            the privacy policies of such sites before sharing any personal
            information through them, initiating any transactions or activating
            the features.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Securing your Information</h2>
          <p className="document__section-paragraph">
            We take the security of your information seriously and go to great
            lengths to protect your personal information from unauthorized
            access, improper use or disclosure, unauthorized modification or
            unlawful destruction or accidental loss. We try hard to keep our
            Services a safe place for all users, but we can’t guarantee it. As a
            result, you understand that your personal information is shared with
            Totem Chat at your own risk. Where required by law, we will notify
            you of any such loss, misuse or alteration of personal information
            that may affect you so you can take the appropriate actions to
            protect your rights.
          </p>
          <p className="document__section-paragraph">
            If you believe your information has been compromised, please contact
            Totem Chat immediately.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Minors</h2>
          <p className="document__section-paragraph">
            Our Services are not intended for or designed to attract children
            under the age of 18, and we will not knowingly solicit or collect
            personal information from children we actually know are under 18. If
            you are not 13 years old or older, please do not use the Services or
            provide any information to us. If we discover that a child under 13
            years old has provided us with personal information, we take steps
            to remove such information. If you believe a child under the age of
            13 has given us personal information, please contact us so we may
            delete the information.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Interpretation</h2>
          <p className="document__section-paragraph">
            The Terms of Service and the Community Guardrails located within the
            App govern the use of the App including the functionality, tools,
            content and promotions. If any part of the Policy conflicts with
            specific terms of a promotion or content within the App, the terms
            of the specific feature will be enforced.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Contact Us</h2>
          <p className="document__section-paragraph">
            If you have questions about the privacy aspects of the Services or
            would like to make a complaint, please contact us at
          </p>
          <p className="document__section-paragraph">Totem Chat, Inc.</p>
          <p className="document__section-paragraph">hello@thetotemchat.com</p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Changes to this Policy</h2>
          <p className="document__section-paragraph">
            This Policy is current as of the Effective Date set forth above. We
            may change this Policy from time to time, so please be sure to check
            back periodically. We will post any changes to this Policy at{" "}
            <a href={PRIVACY} target="_blank" rel="noreferrer">
              https://www.thetotemchat.com/privacy
            </a>
            . If we make any changes to this Policy that materially affect the
            practices with regard to the personal information we have previously
            collected from you, we will endeavor to provide you with notice in
            advance of such change by highlighting the change on the Services.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">
            What Personal Information We Collect
          </h2>
          <p className="document__section-paragraph">
            We collect personal information from you when you voluntarily
            provide it to us, such as by creating a user account, signing up for
            email updates, registering for events, entering contests,
            subscribing to newsletters, ordering products or services, or
            responding to surveys, offers, promotions, and other communications.
            We also may collect personal information about you from your use of
            our products and services or through our partners and other publicly
            and commercially available sources. We have collected Personal
            Information in the following categories marked by an “X” in the last
            12 months:
          </p>
          <p className="document__section-paragraph">
            <b>X</b> Identifiers such as real name, alias, postal address,
            unique personal identifier, online identifier, Internet Protocol
            address, email address, account name, social security number,
            driver’s license number, passport number, or other similar
            identifiers;
          </p>
          <p className="document__section-paragraph">
            <b>X</b> Financial or health information: (examples: physical
            characteristics or description, address, telephone number, bank
            account number, credit card number, debit card number, financial
            information, medical information, health insurance information);
          </p>
          <p className="document__section-paragraph">
            ___ Characteristics of protected classifications under California or
            federal law;
          </p>
          <p className="document__section-paragraph">
            <b>X</b> Commercial information, including records of personal
            property, products or services purchased, obtained or considered, or
            other purchasing or consuming histories or tendencies;
          </p>
          <p className="document__section-paragraph">
            ___ Biometric information;
          </p>
          <p className="document__section-paragraph">
            <b>X</b> Internet or other electronic network activity information,
            including, without limitation, browsing history, search history, and
            information regarding a consumer’s interaction with an Internet Web
            site, application, or advertisement;
          </p>
          <p className="document__section-paragraph">
            <b>X</b> Geolocation data (information that can be used to track an
            electronic device’s location);
          </p>
          <p className="document__section-paragraph">
            ___ Audio, electronic, visual, thermal, olfactory, or similar
            information;
          </p>
          <p className="document__section-paragraph">
            ___ Professional or employment-related information;
          </p>
          <p className="document__section-paragraph">
            ___ Education information, defined as information that is not
            publicly available personally identifiable information as defined in
            the Family Educational Rights and Privacy Act (20 U.S.C. Section
            1232g, 34 C.F.R. Part 99).
          </p>
          <p className="document__section-paragraph">
            <b>X</b> Inferences drawn from any of the information identified in
            this subdivision to create a profile about a consumer reflecting the
            consumer’s preferences, characteristics, psychological trends,
            predispositions, behavior, attitudes, intelligence, abilities, and
            aptitudes.
          </p>
          <p className="document__section-paragraph">
            We collect your Personal Information from both you and through our
            partners and other publicly and commercially available sources as
            well as through the use of cookies. You can read more about our use
            of cookies in our Privacy Policy and our{" "}
            <a href={PRIVACY} target="_blank" rel="noreferrer">
              Cookies Policy
            </a>
            .
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">
            How we use your Personal Information
          </h2>
          <p className="document__section-paragraph">
            We use your Personal Information for the following business purposes
            if marked by an “X”:
          </p>
          <p className="document__section-paragraph">
            ___ Auditing related to a current interaction with the consumer and
            concurrent transactions, including, but not limited to, counting ad
            impressions to unique visitors, verifying positioning and quality of
            ad impressions, and auditing compliance with this specification and
            other standards.
          </p>
          <p className="document__section-paragraph">
            X Detecting security incidents, protecting against malicious,
            deceptive, fraudulent, or illegal activity, and prosecuting those
            responsible for that activity.
          </p>
          <p className="document__section-paragraph">
            ___ Debugging to identify and repair errors that impair existing
            intended functionality.
          </p>
          <p className="document__section-paragraph">
            X Short-term, transient use, provided that the personal information
            is not disclosed to another third party and is not used to build a
            profile about a consumer or otherwise alter an individual consumer’s
            experience outside the current interaction, including, but not
            limited to, the contextual customization of ads shown as part of the
            same interaction.
          </p>
          <p className="document__section-paragraph">
            ___ Performing services on behalf of the business or service
            provider, including maintaining or servicing accounts, providing
            customer service, processing or fulfilling orders and transactions,
            verifying customer information, processing payments, providing
            financing, providing advertising or marketing services, providing
            analytic services, or providing similar services on behalf of the
            business or service provider.
          </p>
          <p className="document__section-paragraph">
            ___ Undertaking internal research for technological development and
            demonstration.
          </p>
          <p className="document__section-paragraph">
            ___ Undertaking activities to verify or maintain the quality or
            safety of a service or device that is owned, manufactured,
            manufactured for, or controlled by the business, and to improve,
            upgrade, or enhance the service or device that is owned,
            manufactured, manufactured for, or controlled by the business.
          </p>
          <p className="document__section-paragraph">
            For all categories of Personal Information collected, we disclose
            such information to our service providers and other third parties to
            help us accomplish the business purposes described above and as
            further outlined in our Privacy Policy.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">
            Personal Information Requests
          </h2>
          <p className="document__section-paragraph">
            As a California resident, you have the right to request certain
            information regarding our use of your Personal Information,
            including the following:
          </p>
          <ul className="document__list">
            <li className="document__list-item">
              The different categories of Personal Information we have collected
              about you during the last 12 months and the categories of sources
              from which that information was collected;
            </li>
            <li className="document__list-item">
              The business or commercial purpose for collecting or selling your
              Personal Information;
            </li>
            <li className="document__list-item">
              The categories of third parties with whom we shared your Personal
              Information;
            </li>
            <li className="document__list-item">
              Whether we have disclosed or sold your Personal Information to a
              third party for a business or commercial purpose during the last
              12 months and the categories of the Personal Information disclosed
              or sold; and
            </li>
            <li className="document__list-item">
              The specific pieces of Personal Information we have collected
              about you.
            </li>
          </ul>
          <p className="document__section-paragraph">
            To submit a request for Personal Information, you must submit a
            Verifiable Consumer Request following the procedures described in
            the Verifiable Consumer Request Procedures section below. You may
            submit a Personal Information request up to twice during a 12-month
            period.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">
            Selling or Sharing of Personal Information
          </h2>
          <p className="document__section-paragraph">
            As a California resident, you have the right to request that we not
            sell your Personal Information. Please note that we do not, and will
            not, sell your Personal Information to third parties.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">
            Right to Request Deletion of Personal Information
          </h2>
          <p className="document__section-paragraph">
            As a California resident, you have a limited right to request that
            we and all of our service providers delete your Personal
            Information. You must do so by submitting a Verifiable Consumer
            Request to delete your Personal Information following the procedures
            described in the Verifiable Consumer Request Procedures section
            below. Upon receipt and confirmation of the Verifiable Consumer
            Request, we will delete your Personal Information from our systems
            and direct our service providers to do the same at no cost to you.
            There are exceptions to this right. We may retain your Personal
            Information for any of the following reasons:
          </p>
          <ul className="document__list">
            <li className="document__list-item">
              To provide goods or services to you as a consumer;
            </li>
            <li className="document__list-item">
              To detect and resolve issues related to security or functionality;
            </li>
            <li className="document__list-item">
              To comply with legal obligations;
            </li>
            <li className="document__list-item">
              To conduct public interest research;
            </li>
            <li className="document__list-item">
              In the exercise of free speech or the free speech of others; and
            </li>
            <li className="document__list-item">
              For use in internal work processes and purposes that you would
              reasonably expect based on your relationship with us.
            </li>
          </ul>
          <p className="document__section-paragraph">
            If we determine that we will not delete your Personal Information
            when you request us to do so, we will inform you and tell you why we
            are not deleting it.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Non-discrimination</h2>
          <p className="document__section-paragraph">
            We will not discriminate against you for the exercise of your rights
            under the CCPA. We will not deny you goods or services, charge a
            different rate or price to you, or supply a different level or
            quality of goods to you. We may, however, offer different prices,
            levels of service or quality to those who share their Personal
            Information based on the value of the Personal Information provided
            as permitted by law. To the extent certain of our services require
            your Personal Information and you choose not to provide the
            necessary Personal Information, you may not be able to use those
            services.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">
            Verifiable consumer request procedures
          </h2>
          <p className="document__section-paragraph">
            In order to submit a Verifiable Consumer Request, please submit your
            name, customer or account email address, and a description of your
            request with sufficient detail that allows us to properly
            understand, evaluate, and respond to it, to:
          </p>
          <p className="document__section-paragraph">Totem Chat, Inc.</p>
          <p className="document__section-paragraph">hello@thetotemchat.com</p>
          <p className="document__section-paragraph">
            If you maintain an online account with us, we may verify your
            identity for a request through the normal account authentication
            process.
          </p>
          <p className="document__section-paragraph">
            You may assign a designated agent to make a request on your behalf.
            If you wish to do so, you will need to appoint the designated agent
            in writing, and we may require a copy of that writing before
            allowing any request submitted by your designated agent. The
            designated agent would follow the same procedure outlined above to
            make a request on your behalf.
          </p>
          <p className="document__section-paragraph">
            If we are unable to confirm your identity or authority to make the
            request, we may contact you for additional information or deny your
            request. We will inform you if we cannot verify your identity or
            authority. We will only use Personal Information provided in a
            Verifiable Consumer Request to verify your identity or authority to
            make the request.
          </p>
          <p className="document__section-paragraph">
            We will respond to the request within 45 days of its receipt. If we
            require more time (up to 90 days), we will inform you of the reason
            and extension period in writing. The information may be delivered
            through your account, or, if you do not maintain an account with us,
            by mail or electronically at your option, and if provided
            electronically, the information will be in a portable and, to the
            extent technically feasible, readily useable format that allows you
            to transmit the information to another entity without hindrance.
          </p>
          <p className="document__section-paragraph">
            We are not required to respond to requests to provide Personal
            Information to you more than twice in any 12-month period. Any
            disclosures we provide will only cover the 12-month period preceding
            the receipt of the request. The response we provide will also
            explain the reasons we cannot comply with a request, if applicable.
          </p>
          <p className="document__section-paragraph">
            We do not charge a fee to process or respond to your request unless
            it is excessive, repetitive, or manifestly unfounded. If we
            determine that the request warrants a fee, we will tell you why we
            made that decision and provide you with a cost estimate before
            completing your request.
          </p>
          <p className="document__section-paragraph">
            In responding to your request, we are not permitted to disclose or
            provide you with your Social Security Number, Driver’s License
            Number, or other government issued identification number, financial
            account number, any health insurance or medical identification
            number, an account password, or security questions and answers.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Do Not Track</h2>
          <p className="document__section-paragraph">
            We currently do not respond to any Do Not Track signals or similar
            signals.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">Additional Rights</h2>
          <p className="document__section-paragraph">
            The rights set forth here are in addition to the rights contained in
            our Privacy Policy. In the event the rights here conflict with those
            contained in our Privacy Policy, the portion that provides you with
            the most protection with regard to your Personal Information will
            prevail.
          </p>
        </section>
        <section className="document__section">
          <h2 className="document__section-title">How to Contact Us</h2>
          <p className="document__section-paragraph">
            If you have any questions or concerns, please contact us at:
          </p>
          <p className="document__section-paragraph">Totem Chat, Inc.</p>
          <p className="document__section-paragraph">hello@thetotemchat.com</p>
        </section>
      </div>
    </main>
    </>
  );
};

export default PrivacyPolicy;
